<template>
    <div class="modal_scheduleTable">
        <div class="header">
            <h3>定時処理の予定表</h3>
        </div>
        <p class="scheduleTable_lastUpdated">最終更新日 {{ lastUpdated }}</p>
        <p class="scheduleTable_note">※本番の予定です。検証環境は時刻が違うものがあります</p>

        <h4>毎日</h4>
        <table class="scheduleTable">
            <thead>
                <tr>
                    <th class="scheduleTable_time">時刻</th>
                    <th class="scheduleTable_system">システム</th>
                    <th>内容</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(schedule, index) in dailySchedules" :key="'daily' + index">
                    <td class="scheduleTable_time">{{ schedule.time }}</td>
                    <td class="scheduleTable_system">
                        <span class="systemLabel" :class="systemClass(schedule.system)">{{ schedule.system }}</span>
                    </td>
                    <td>{{ schedule.content }}</td>
                </tr>
            </tbody>
        </table>

        <h4>曜日・随時・毎月・毎年</h4>
        <table class="scheduleTable">
            <thead>
                <tr>
                    <th class="scheduleTable_time">いつ</th>
                    <th class="scheduleTable_system">システム</th>
                    <th>内容</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(schedule, index) in otherSchedules" :key="'other' + index">
                    <td class="scheduleTable_time">{{ schedule.time }}</td>
                    <td class="scheduleTable_system">
                        <span class="systemLabel" :class="systemClass(schedule.system)">{{ schedule.system }}</span>
                    </td>
                    <td>{{ schedule.content }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { SCHEDULE_LAST_UPDATED, SYSTEM, DAILY_SCHEDULES, OTHER_SCHEDULES } from '../helpers/scheduleTable'

export default {
    data() {
        return {
            lastUpdated: SCHEDULE_LAST_UPDATED,
            dailySchedules: DAILY_SCHEDULES,
            otherSchedules: OTHER_SCHEDULES,
        }
    },
    methods: {
        systemClass(system) {
            return system === SYSTEM.AM ? 'systemLabel__am' : 'systemLabel__pochi'
        },
    },
}
</script>

<style scoped lang="sass">
.modal_scheduleTable
    padding: 16px 32px
    color: $grayColor
    .header
        padding: 5px
        margin-bottom: 5px
        h3
            font-size: 20px
    h4
        font-size: 1.6rem
        margin: 20px 0 8px
    .scheduleTable_lastUpdated
        font-size: 1.4rem
    .scheduleTable_note
        font-size: 1.3rem
        margin-top: 4px
.scheduleTable
    width: 100%
    border-collapse: collapse
    font-size: 1.3rem
    th, td
        padding: 6px 8px
        border-bottom: 1px solid #ddd
        text-align: left
        vertical-align: top
    th
        background: $mainColor
        color: $whiteColor
        font-weight: normal
    .scheduleTable_time
        width: 220px
        white-space: nowrap
    .scheduleTable_system
        width: 80px
        white-space: nowrap
.systemLabel
    display: inline-block
    padding: 1px 8px
    border-radius: 3px
    color: $whiteColor
    font-size: 1.1rem
    &__am
        background: $grayColor
    &__pochi
        background: $mainColor
</style>
